import { FC, MouseEvent, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { Menu, MenuItem, useMediaQuery } from "@mui/material";
import { SaveAlt } from "@mui/icons-material";
import { Theme } from "@mui/material/styles";

import { StyledButton } from "./styled";

export interface IExportButtonProps {
  disabled?: boolean;
  handleExport: (format?: "png" | "jpg" | "csv") => void;
  type?: "image" | "csv";
  showCsvInImageMenu?: boolean;
}

export const DataExportButton: FC<IExportButtonProps> = props => {
  const { disabled, handleExport, type = "csv", showCsvInImageMenu = false } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [searchParams] = useSearchParams();
  const onlyPage = searchParams.get("onlyPage") === "true";

  const isBelowXL = useMediaQuery((theme: Theme) => theme.breakpoints.down("xl"));

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportClick = (format?: "png" | "jpg" | "csv") => {
    handleClose();
    handleExport(format);
  };

  return (
    <>
      <StyledButton
        startIcon={<SaveAlt />}
        id="export-button"
        aria-controls={open ? "export-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        disabled={disabled}
        sx={{
          minWidth: 0,
          ...(isBelowXL && { minWidth: 0, justifyContent: "flex-end", pr: 0, pl: "12px" }),
        }}
      >
        {(!isBelowXL || onlyPage) && <FormattedMessage id="form.buttons.export" />}
      </StyledButton>
      <Menu
        id="export-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "export-button",
        }}
      >
        {type === "csv" ? (
          <MenuItem onClick={() => handleExportClick()}>
            <FormattedMessage id="form.buttons.downloadCsv" />
          </MenuItem>
        ) : (
          [
            <MenuItem key="png" onClick={() => handleExportClick("png")}>
              <FormattedMessage id="form.buttons.downloadPng" />
            </MenuItem>,
            <MenuItem key="jpg" onClick={() => handleExportClick("jpg")}>
              <FormattedMessage id="form.buttons.downloadJpg" />
            </MenuItem>,
            ...(showCsvInImageMenu
              ? [
                  <MenuItem key="csv" onClick={() => handleExportClick("csv")}>
                    <FormattedMessage id="form.buttons.downloadCsv" />
                  </MenuItem>,
                ]
              : []),
          ]
        )}
      </Menu>
    </>
  );
};
